export class ElhubPopoverModel {
  constructor(options = {}) {
    this.target         = options.target        || null;
    this.width          = options.width         || 800;
    this.visible        = options.visible       || false;
    this.position       = options.position      || 'top';
    this.loaderVisible  = options.loaderVisible || false;
    this.data   = [];
    this.error  = new ElhubPopoverError();
    this.ref = 'popup-elem';
  }
}

export class ElhubPopoverError {
  constructor(title = null, description = null, visible = false) {
    this.title        = title;
    this.description  = description;
    this.visible      = visible;
  }
}
